import React, { useState } from "react";
import SectionTitle from "./SectionTitle";
// import Amazon from "./works/Amazon";
// import Apple from "./works/Apple";
import Velxgen from "./works/Velxgen.jsx";
import UOJ from "./works/UOJ";
// import Splash from "./works/Splash";

const Experience = () => {
  const [workUOJ, setWorkUOJ] = useState(true);
  const [workVelxgen, setWorkVelxgen] = useState(false);
  // const [workApple, setWorkApple] = useState(false);
  // const [workSplash, setWorkSplash] = useState(false);
  // const [workAmazon, setWorkAmazon] = useState(false);

  const handleUOJ = () => {
    setWorkUOJ(true);
    setWorkVelxgen(false);
    // setWorkApple(false);
    // setWorkSplash(false);
    // setWorkAmazon(false);
  };

  const handleVelxgen = () => {
    setWorkUOJ(false);
    setWorkVelxgen(true);
  //   setWorkApple(false);
  //   setWorkSplash(false);
  //   setWorkAmazon(false);
  };

  // const handleApple = () => {
  //   setWorkUOJ(false);
  //   setWorkGoogle(false);
  //   setWorkApple(true);
  //   setWorkSplash(false);
  //   setWorkAmazon(false);
  // };
  
  // const handleSplash = () => {
  //   setWorkUOJ(false);
  //   setWorkGoogle(false);
  //   setWorkApple(false);
  //   setWorkSplash(true);
  //   setWorkAmazon(false);
  // };
  
  // const handleAmazon = () => {
  //   setWorkUOJ(false);
  //   setWorkGoogle(false);
  //   setWorkApple(false);
  //   setWorkSplash(false);
  //   setWorkAmazon(true);
  // };

  return (
    <section
      id="experience"
      className="max-w-containerxs mx-auto py-10 lgl:py-24 px-4"
    >
      <SectionTitle title="Where I have Worked" titleNo="02" />
      <div className="w-full mt-10 flex flex-col md:flex-row gap-16">
        <ul className="md:w-32 flex flex-col">
          <li
            onClick={handleUOJ}
            className={`${
              workUOJ
                ? "border-l-textGreen text-textGreen"
                : "border-l-hoverColor text-textDark"
            } border-l-2 bg-transparent hover:bg-[#112240] py-3 text-sm  cursor-pointer duration-300 px-8 font-medium`}
          >
            UOJ
          </li>
          <li
            onClick={handleVelxgen}
            className={`${
              workVelxgen
                ? "border-l-textGreen text-textGreen"
                : "border-l-hoverColor text-textDark"
            } border-l-2 bg-transparent hover:bg-[#112240] py-3 text-sm  cursor-pointer duration-300 px-8 font-medium`}
          >
            Velxgen
          </li>
          {/* <li
            onClick={handleApple}
            className={`${
              workApple
                ? "border-l-textGreen text-textGreen"
                : "border-l-hoverColor text-textDark"
            } border-l-2 bg-transparent hover:bg-[#112240] py-3 text-sm  cursor-pointer duration-300 px-8 font-medium`}
          >
            Apple
          </li> */}
          {/* <li
            onClick={handleSplash}
            className={`${
              workSplash
                ? "border-l-textGreen text-textGreen"
                : "border-l-hoverColor text-textDark"
            } border-l-2 bg-transparent hover:bg-[#112240] py-3 text-sm  cursor-pointer duration-300 px-8 font-medium`}
          >
            Splash
          </li> */}
          {/* <li
            onClick={handleAmazon}
            className={`${
              workAmazon
                ? "border-l-textGreen text-textGreen"
                : "border-l-hoverColor text-textDark"
            } border-l-2 bg-transparent hover:bg-[#112240] py-3 text-sm  cursor-pointer duration-300 px-8 font-medium`}
          >
            Amazon
          </li> */}
        </ul>
        {workUOJ && <UOJ />}
        {workVelxgen && <Velxgen />}
        {/* {workApple && <Apple />} */}
        {/* {workSplash && <Splash />} */}
        {/* {workAmazon && <Amazon />} */}
      </div>
    </section>
  );
};

export default Experience;
